import React, { useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../utils/css/rightDiv.css";
import useFetchWidgets from "./useFetchWidgets";
import { CircularProgress } from "@mui/material";
import CarouselItem from "./CarouselItem";
import { isMobile } from "../../utils/miscutils";

export default function Carousel({
  pageId,
  carouselId,
  children,
  itemClassnames,
  slidesToShow = 3,
  bannerOnClick = () => {},
}) {
  const shouldFetch = pageId && carouselId;
  const shouldUseChildren = !pageId && !carouselId;

  const { banners, loading, error } = useFetchWidgets({
    pageId,
    carouselId,
    enabled: shouldFetch,
  });

 
  const internalSlidesToShow = isMobile(window.innerWidth) ? 1 : Math.min(slidesToShow, banners.length);

  var settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    dots: true,
    infinite: banners.length > internalSlidesToShow,
    speed: 500,
    slidesToShow: internalSlidesToShow,
    slidesToScroll: internalSlidesToShow,
    arrows: false,
    draggable: true,
    touchMove: true,
  };
  if (loading) return <CircularProgress />;
  if (error) return null;

  if (!shouldFetch && !shouldUseChildren) {
    // This case means one is present and the other is not, which is invalid.
    console.error(
      "Carousel: Invalid props. Either both pageId and carouselId must be provided, or neither (to use children)."
    );
    return null;
  }

  return (
    <Slider
      {...settings}
      aria-label="R2C Banners"
      className="mb-carousel"
    >
      {shouldFetch
        ? banners.map((banner) => (
            <CarouselItem
              key={banner.widgetId}
              onClick={() => banner.properties.onClick && bannerOnClick(banner.properties.onClick?.value, pageId, carouselId, banner.altText)}
              className={itemClassnames}
              src={banner.properties.contentUrl}
              alt={banner.altText}
              ariaLabel={banner.altText}
            />
          ))
        : children}
    </Slider>
  );
}
